module.exports = __webpack_public_path__ + "img/plan-family.b509e33.png";